import { useEffect, useState } from "react";
import { ProductInclusion } from "../../../../../../graphql/operations";
import useWindowSize from "../../../../../../utils/useWindowSize";
import InclusionCard from "./InclusionCard";

type InclusionProps = {
  inclusion: ProductInclusion;
  onReadMore?: () => void;
};

const MAX_TITLE_LENGTH = 100;

const truncateText = (text: string, maxLength: number) =>
  text.length <= maxLength
    ? text
    : `${text.slice(0, maxLength - 3).trimEnd()}...`;

export default function Inclusion({ inclusion, onReadMore }: InclusionProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const isMobileScreen = useWindowSize().isMobile;

  useEffect(() => {
    setIsExpanded(false);
  }, [isMobileScreen]);

  const truncatedTitle = truncateText(
    inclusion.translation.title,
    MAX_TITLE_LENGTH
  );

  const expandCard = () => setIsExpanded((isExpanded) => !isExpanded);

  return (
    <InclusionCard
      title={truncatedTitle}
      description={inclusion.translation.description}
      icon={inclusion.icon}
      isExpanded={isExpanded}
      onReadMore={onReadMore ?? expandCard}
    />
  );
}
